var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargerTimeToPlugin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 167,
    viewBox: "0 0 167 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15679_6590",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 167,
    height: 167
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3172 166.634C129.332 166.634 166.634 129.332 166.634 83.3172C166.634 37.3024 129.332 0 83.3172 0C37.3024 0 0 37.3024 0 83.3172C0 129.332 37.3024 166.634 83.3172 166.634Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15679_6590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-119.752 112.64L-24.4559 58.183L-388.153 -170.635L454.861 -206.762L75.4991 13.6234L169.59 69.1557L515.074 273.098L-606.129 390.573L-119.752 112.64Z",
    fill: "url(#paint0_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.863 -206.762V-96.5694L169.592 69.1557L75.501 13.6234L454.863 -206.762Z",
    fill: "url(#paint1_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5344 134.195C57.2908 131.264 50.8047 131.522 45.8877 134.972C34.2993 143.104 28.8659 156.818 26.5464 164.954C25.4452 168.814 26.8708 172.948 30.1084 175.32L37.9164 181.047L62.5344 134.192V134.195Z",
    fill: "#004158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1392 89.0245C96.4349 92.1142 97.9532 107.507 99.0721 108.628C100.312 109.869 104.216 107.629 104.216 107.629C104.216 107.629 104.106 117.24 100.73 125.465C100.045 127.14 99.2222 128.749 98.2401 130.21C94.1508 136.316 82.8382 145.806 76.5 150.886C73.9841 152.894 70.3758 152.709 68.0718 150.469L67.9968 150.394C68.9303 144.047 67.3678 139.902 65.9245 137.554C65.7943 137.36 65.6839 137.148 65.5449 136.963C65.5074 136.908 65.461 136.844 65.4147 136.786C64.6202 135.676 63.9802 135.158 63.9802 135.158L63.6205 134.946C63.6205 134.946 63.6205 134.937 63.6116 134.937L63.519 134.882L62.4839 134.299H62.4751L61.2436 133.577L61.1973 133.549L61.1421 133.511L61.0781 133.474H61.0693L60.8464 133.344C60.6809 133.288 60.5132 133.233 60.3366 133.178C60.3278 133.169 60.3189 133.169 60.3079 133.169H60.2903C56.2384 131.902 51.9835 131.68 48.1346 133.992L48.1258 134.001H48.117C42.1319 137.59 37.5614 143.003 34.1297 148.6C34.1297 148.609 34.1296 148.617 34.1208 148.617C29.9763 155.379 27.5067 162.428 26.2025 166.906V166.924C26.2025 166.924 26.1936 166.952 26.1936 166.961C25.3705 169.802 25.0196 171.587 25.0196 171.587L24.6223 175.74L24.4105 178.007C24.2449 179.737 23.2827 181.311 21.8019 182.244L-70.376 240.544L-81.2648 246.908C-82.9862 247.908 -85.1136 246.584 -84.9658 244.596L-84.6326 240.173L-84.6237 240.071V240.054L-84.4759 238.121C-84.4759 238.121 -84.4207 237.889 -84.3567 237.474C-84.3567 237.456 -84.3479 237.436 -84.3479 237.41C-84.125 235.764 -83.7917 231.48 -85.864 227.66C-87.5015 224.654 -89.9799 222.794 -92.1912 221.655C-92.6348 221.423 -93.0695 221.22 -93.4866 221.044C-93.6257 220.98 -93.7735 220.924 -93.9126 220.878H-93.9214C-93.9214 220.878 -93.9391 220.869 -93.9501 220.869C-96.0511 220.101 -98.3639 220.075 -100.471 220.814C-114.792 225.857 -122.582 244.348 -125.8 254.174C-125.809 254.22 -125.818 254.257 -125.829 254.284C-125.994 254.794 -126.153 255.275 -126.281 255.727C-126.29 255.745 -126.29 255.765 -126.299 255.782C-126.531 256.449 -126.78 257.087 -127.058 257.707C-132.266 269.723 -144.19 272.758 -157.421 274.378C-171.788 276.145 -205.231 268.891 -231.539 247.919C-244.24 237.798 -248.967 224.837 -249.643 212.377C-249.373 207.465 -248.541 202.737 -247.44 198.427L-238.624 214.681C-238.253 215.365 -237.235 215.264 -237.004 214.524L-233.876 204.662C-233.654 203.949 -233.691 203.19 -233.978 202.497L-241.731 184.197C-241.232 183.438 -240.557 182.542 -239.723 181.542C-229.897 169.729 -198.509 142.586 -188.582 134.076H-188.573C-186.666 132.439 -185.548 131.494 -185.548 131.494C-185.548 131.494 -179.099 125.268 -170.375 116.573C-170.291 116.489 -170.218 116.417 -170.135 116.333C-161.439 107.673 -150.55 96.6383 -141.511 86.8772C-123.269 67.1806 -99.3084 46.972 -63.7751 36.2001C-22.0382 23.5458 15.5453 21.7891 15.5453 21.7891C15.5453 21.7891 15.563 21.7891 15.5917 21.7979C33.0108 24.6293 63.4572 33.0752 82.5049 49.9668C91.7188 58.1456 97.1036 65.574 100.202 71.078C102.034 74.3244 103.06 76.8866 103.616 78.5439C104.08 79.8857 104.216 80.6162 104.216 80.6162V83.9288L96.5651 88.23C96.2694 88.3867 96.1127 88.7023 96.1392 89.0267V89.0245Z",
    fill: "url(#paint2_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-76.1762 190.899C-54.8266 177.024 32.3239 120.428 50.8553 108.396C55.0793 105.653 58.9943 102.458 62.4305 98.7742C62.4922 98.708 62.554 98.6418 62.6158 98.5734C65.0589 95.9318 62.7151 91.6791 59.1775 92.3367C48.1562 94.3869 27.2855 100.209 -2.34872 116.745C-34.607 134.745 -67.2074 175.753 -77.5445 189.434C-78.2308 190.343 -77.1318 191.519 -76.1762 190.897V190.899Z",
    fill: "url(#paint3_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.7986 33.2735C-35.8425 32.8322 -35.6814 31.3116 -34.5691 31.0931C-29.725 30.1397 -19.2995 28.3124 0.931118 25.609C9.78741 24.4261 13.4818 25.9665 19.0542 28.8575C34.3215 36.7781 59.9194 50.3549 75.3942 62.3826C78.5964 64.8719 78.2278 69.8154 74.688 71.7972L54.9031 82.8692C53.7423 83.5203 52.3166 83.4585 51.2154 82.7103C41.9817 76.4185 -1.22503 47.4595 -34.8008 33.2757L-34.7986 33.2735Z",
    fill: "url(#paint4_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3915 164.54C56.5942 177.479 45.189 184.87 37.9172 181.05C30.6455 177.23 30.2615 163.644 37.061 150.705C43.8582 137.766 55.5062 129.947 62.5352 134.195C70.0078 138.71 70.191 151.601 63.3915 164.54Z",
    fill: "#004158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.213 83.9307V107.631C104.213 107.631 100.314 109.866 99.0713 108.626C97.9524 107.507 96.4385 92.1183 96.1406 89.0286C96.1141 88.702 96.273 88.3864 96.5621 88.2275L104.213 83.9307Z",
    fill: "#007FBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1512 161.904C65.4005 151.914 65.385 141.571 60.1164 138.803C54.8479 136.034 46.3215 141.888 41.0721 151.878C35.8228 161.869 35.8384 172.211 41.1069 174.98C46.3754 177.748 54.9019 171.894 60.1512 161.904Z",
    fill: "#007FBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.118 134.003C42.1329 137.592 37.5624 143.005 34.1307 148.602C34.1307 148.611 34.1307 148.619 34.1218 148.619C29.9773 155.381 27.5078 162.43 26.2035 166.908V166.926C25.3715 169.784 25.0184 171.589 25.0184 171.589L24.6211 175.742L24.4093 178.009C24.2437 179.739 23.2815 181.313 21.8007 182.246L-70.3772 240.546L-81.266 246.91C-82.9874 247.91 -85.1149 246.586 -84.967 244.598L-84.6249 240.074V240.056L-84.4771 238.123C-84.4771 238.123 -84.4219 237.891 -84.3579 237.476C-84.135 235.876 -83.7664 231.528 -85.8652 227.66C-87.5027 224.654 -89.9811 222.793 -92.1924 221.655C-83.1904 224.98 -81.7074 235.982 -81.4823 240.486C-81.4404 241.34 -80.4914 241.828 -79.7675 241.373L16.8065 180.553C18.3403 179.587 19.4746 178.106 20.0043 176.373C20.8098 173.745 21.8713 168.455 25.4664 158.851C28.2515 151.407 32.0363 146.563 35.3224 143.109C41.2523 136.877 47.7296 134.171 48.118 134.005V134.003Z",
    fill: "url(#paint5_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1123 88.3071L74.5049 95.7973L85.2679 91.6373L81.0549 84.2949L73.1123 88.3071Z",
    fill: "#007FBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7082 104.082C87.7082 104.082 85.9802 92.3301 84.9253 90.3041C83.8704 88.2671 79.6575 85.5151 79.6575 85.5151L75.1885 87.8545L77.5874 90.004C77.5874 90.004 80.7124 91.5069 80.7874 92.7118C80.7984 92.9458 80.9044 93.4048 81.0544 93.9918C81.7165 96.4547 83.3143 101.211 83.3143 101.211L84.4751 103.208L87.706 104.08L87.7082 104.082Z",
    fill: "#002F3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0542 93.9941L76.1173 93.0341L75.1904 87.8567L77.5893 90.0062C77.5893 90.0062 80.7143 91.5091 80.7893 92.7141C80.8004 92.948 80.9063 93.4071 81.0564 93.9941H81.0542Z",
    fill: "#7A54C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.48 130.874C147.659 136.102 146.84 157.628 146.84 157.628C147.94 169.212 146.84 197.577 146.84 197.577C140.5 200.051 134.157 195.366 134.157 195.366V162.02C134.157 155.401 131.361 141.312 131.361 141.312L121.344 160.38C121.082 160.892 121.066 161.479 121.315 162.006C126.601 173.707 130.015 198.676 130.015 198.676C126.705 200.609 119.824 198.676 119.824 198.676L106.938 161.611C106.542 160.439 106.514 159.166 106.878 157.979L119.824 115.701L126.707 109.449L148.482 111.294C150.138 117.078 149.317 125.63 148.482 130.874H148.48Z",
    fill: "#002F3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4421 97.3992C91.4421 97.3992 86.1654 97.5139 83.1993 98.5159C80.2332 99.5156 75.3626 94.72 75.2169 94.517C75.0713 94.3139 75.4531 91.2772 78.2095 91.5531C80.9659 91.829 83.9408 93.1752 85.0686 92.3674C86.1941 91.5597 91.1221 93.1068 91.1221 93.1068",
    fill: "#FFDFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.008 58.2752L141.043 47.9116C140.079 37.548 124.642 39.3775 124.642 39.3775L124.752 58.2443C124.752 58.9218 125.26 59.4912 125.955 59.6148C127.513 59.8906 130.327 60.1533 132.869 59.1315V59.4029V64.3729L142.008 63.8322V57.4145",
    fill: "#FFDFC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.768 82.9067C117.768 82.9067 110.723 109.367 115.272 112.537C119.82 115.706 124.686 117.5 131.81 118.162C143.939 119.29 144.844 110.248 151.657 111.296C159.728 112.537 157.858 76.8399 155.654 72.5651C153.449 68.2926 145.453 63.6448 142.008 63.8324C138.563 64.02 132.87 64.3731 132.87 64.3731L125.468 69.396L117.766 82.9067H117.768Z",
    fill: "url(#paint6_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.569 35.7138C124.263 36.9364 123.02 41.1119 125.32 43.7844C125.746 44.2788 126.273 44.7775 126.922 45.2653C129.403 47.1257 136.529 47.1102 136.529 47.1102V51.6145C136.529 51.6145 139.181 50.0896 140.216 52.5194C141.179 54.7792 138.385 56.7632 138.385 56.7632C138.385 56.7632 143.973 57.8159 145.317 56.4719C146.661 55.1279 150.072 46.9624 146.453 41.3789C142.836 35.7977 137.374 34.4448 131.671 34.8663C130.005 34.9899 128.652 35.3121 127.569 35.7116V35.7138Z",
    fill: "#002F3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1914 92.1999C87.1914 92.1999 90.7158 96.777 90.2502 98.8316C90.2502 98.8316 111.366 104.552 114.564 101.482C117.761 98.4123 130.833 84.2219 132.554 80.9932C134.726 76.9193 134.666 72.1744 130.537 69.6983C125.289 66.549 121.577 71.0379 118.567 75.5046C115.559 79.9714 106.398 93.599 106.398 93.599L87.1936 92.2021L87.1914 92.1999Z",
    fill: "url(#paint7_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.657 139.708C111.052 149.612 103.917 156.405 97.6914 159.221C95.2285 160.331 92.8186 160.894 90.6867 160.927C88.3187 160.958 86.2928 160.329 84.951 159.04C75.6202 150.116 81.89 130.569 84.909 121.174C85.538 119.234 86.0279 117.698 86.2199 116.771C87.3499 111.482 84.7281 102.643 84.706 102.568L87.266 103.751C87.3631 104.06 89.559 111.376 88.3099 117.217C88.0958 118.241 87.5838 119.83 86.946 121.834C84.0572 130.812 78.0632 149.493 86.423 157.502C88.3099 159.314 92.4897 159.219 96.8087 157.277C102.438 154.739 108.889 148.63 108.527 139.789C108.229 132.326 105.914 122.397 103.632 114.251C103.846 112.821 104.074 110.661 104.189 108.522C106.854 117.341 110.286 130.289 110.659 139.703L110.657 139.708Z",
    fill: "url(#paint8_linear_15679_6590)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.743 0.436874C90.7279 7.56958 79.3292 14.9384 74.0724 25.6772C71.4594 31.0091 70.4156 36.288 70.8834 41.4168C70.1375 40.9799 69.3585 40.4899 68.6876 40.0949C68.4845 35.4251 69.4335 30.2852 72.1524 24.7393C77.6763 13.4686 89.3199 5.94089 100.591 -1.34189C115.721 -11.1317 128.784 -19.5864 123.633 -34.7169C118.312 -50.3484 111.85 -52.7583 106.156 -54.8813C99.8115 -57.2493 94.3318 -59.2951 93.8198 -77.9457C93.4247 -92.2133 95.5787 -105.051 97.2956 -115.364C99.7365 -129.962 101.359 -139.611 94.4907 -142.383L90.0658 -144.462V-146.808L95.3447 -144.334C103.738 -140.942 101.924 -130.066 99.4076 -115.011C97.6907 -104.795 95.5698 -92.0632 95.9516 -77.9986C96.4217 -60.7892 100.824 -59.1451 106.902 -56.8852C112.735 -54.7004 119.996 -51.9903 125.648 -35.4098C131.341 -18.7014 116.968 -9.4015 101.74 0.439072L101.743 0.436874Z",
    fill: "url(#paint9_linear_15679_6590)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15679_6590",
    x1: -575.647,
    y1: 126.672,
    x2: 697.781,
    y2: -23.6445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00BDDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#13C2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#45CFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#96E4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D0F4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15679_6590",
    x1: 75.501,
    y1: -68.8044,
    x2: 454.863,
    y2: -68.8044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#00577C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00699A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0075AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#007DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#0080C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3DD2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#A2E9F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15679_6590",
    x1: -249.645,
    y1: 148.211,
    x2: 104.216,
    y2: 148.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#004158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#00577C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00699A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0075AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#007DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0080C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#004158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15679_6590",
    x1: -77.7608,
    y1: 141.672,
    x2: 63.62,
    y2: 141.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00E7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15679_6590",
    x1: -35.4982,
    y1: 54.2612,
    x2: 77.5856,
    y2: 54.2612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#00E7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15679_6590",
    x1: -85.0707,
    y1: 149.257,
    x2: 61.8317,
    y2: 239.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B1E5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#73D7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#41CBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1DC3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#07BDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#00BCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15679_6590",
    x1: 119.037,
    y1: 75.8291,
    x2: 153.818,
    y2: 110.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0080C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#007DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0075AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00699A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#00577C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15679_6590",
    x1: 100.353,
    y1: 113.041,
    x2: 117.281,
    y2: 66.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3DD2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0080C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#007DBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#0075AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00699A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#00577C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15679_6590",
    x1: 80.0318,
    y1: 131.748,
    x2: 110.672,
    y2: 131.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00E7A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15679_6590",
    x1: 68.6589,
    y1: -52.6987,
    x2: 126.921,
    y2: -52.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#00E7A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E7A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerTimeToPlugin);
export default __webpack_public_path__ + "static/media/charger-time-to-plugin.210d39afdbc645a4e108607294b01f9e.svg";
export { ForwardRef as ReactComponent };